export const EXAMPLE_COLOR_CODES = {
	light: [
		{
			value: '#1C1C1C',
			name: 'black',
		},
		{
			value: '#6936BD',
			name: 'purple',
		},
		{
			value: '#0059E1',
			name: 'blue',
		},
		{
			value: '#5FC8D6',
			name: 'cyan',
		},
		{
			value: '#73D943',
			name: 'green',
		},
		{
			value: '#FFCA00',
			name: 'yellow',
		},
		{
			value: '#FF6D03',
			name: 'orange',
		},
		{
			value: '#DA3807',
			name: 'red',
		},
		{
			value: '#D92685',
			name: 'pink',
		},
	],
	dark: [
		{
			value: '#F2F2F2',
			name: 'white',
		},
		{
			value: '#8347FF',
			name: 'electric violet',
		},
		{
			value: '#2472E8',
			name: 'azure',
		},
		{
			value: '#6CDAE8',
			name: 'light sea green',
		},
		{
			value: '#97E556',
			name: 'light lime',
		},
		{
			value: '#FDCF1E',
			name: 'golden yellow',
		},
		{
			value: '#FF8731',
			name: 'orange peel',
		},
		{
			value: '#EE5433',
			name: 'cinnabar',
		},
		{
			value: '#CE3988',
			name: 'deep cerise',
		},
	],
}

export const SAMPLE_BACKGROUND_IMAGES = {
	light: [
		'https://cdn.files-text.com/api/ow/img/product/backgrounds/bg1_light.png',
		'https://cdn.files-text.com/api/ow/img/product/backgrounds/bg2_light.png',
		'https://cdn.files-text.com/api/ow/img/product/backgrounds/bg3_light.png',
		'https://cdn.files-text.com/api/ow/img/product/backgrounds/bg4_light.png',
	],
	dark: [
		'https://cdn.files-text.com/api/ow/img/product/backgrounds/bg1_dark.png',
		'https://cdn.files-text.com/api/ow/img/product/backgrounds/bg2_dark.png',
		'https://cdn.files-text.com/api/ow/img/product/backgrounds/bg3_dark.png',
		'https://cdn.files-text.com/api/ow/img/product/backgrounds/bg4_dark.png',
	],
} as const
